exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slider-editor__slider{margin:0 20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5c30e106","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/image-filter/image-editor/slider-editor/slider-editor.vue
// module id = 212
// module chunks = 0